module.exports = __webpack_public_path__ + "img/pCoupon.ec48af0d.svg";